import React, { Component } from "react";
import AdminUserListItem from './AdminUserListItem.js';
import AdminPortList from './AdminPortList.js';
import AdminPOIList from './AdminPOIList.js';

class AdminTools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0
        }
    }
    render() {
        const users = this.props.users;
        const boats = structuredClone(this.props.boats);

        if (!boats) return (<>No boats found</>);
        if (!users) return (<>No users found</>);
        // console.log(boats)

        let userList = [];
        for (let i = 0; i < users.length; i++) {
            const userBoats = boats.find(o => o.userId === users[i]._id)
            if (userBoats) {
                const index = boats.indexOf(boats.find(o => o.userId === users[i]._id));
                boats.splice(index, 1);
            }

            userList.push(<AdminUserListItem user={users[i]} boats={userBoats} key={users[i]._id} />)
        }
        if (boats.length > 0) {
            userList.push(<AdminUserListItem user={0} boats={boats} key='boatsWithoutUser' />)
        }

        return (
            <div id="AdminTools">
                <div className="tabContainer">
                    <span className={this.state.selectedTab == 0 ? 'tab selected' : 'tab'} onClick={() => this.switchTab(0)} >Bateaux</span>
                    <span className={this.state.selectedTab == 1 ? 'tab selected' : 'tab'} onClick={() => this.switchTab(1)}>Ports</span>
                    <span className={this.state.selectedTab == 2 ? 'tab selected' : 'tab'} onClick={() => this.switchTab(2)}>POI</span>
                </div>
                {this.state.selectedTab == 0 ?
                    <ul className='AdminUserList'>
                        {userList}
                    </ul>
                    : null
                }
                {this.state.selectedTab == 1 ?
                    <AdminPortList ports={this.props.ports} selectedPort={this.props.selectedPort} getPortData={this.props.getPortData} />
                    : null
                }
                {this.state.selectedTab == 2 ?
                    <AdminPOIList POIs={this.props.POIs} selectedPOI={this.props.selectedPOI} getPOIData={this.props.getPOIData} />
                    : null
                }
            </div>
        );
    }
    switchTab(tab) {
        if (this.state.selectedTab != tab) {
            this.setState({ selectedTab: tab });
        }
    }
}


export default AdminTools;
